<button
  *transloco="let t; read: 'shared.betaFeature.badge'"
  class="cursor-pointer rounded-full bg-nordic-blue px-3 py-1 text-body-small text-white-high-emphasis"
  (click)="onBadgeClick($event)"
>
  {{ t('label') }}
</button>
